import { Text } from "../../global/styles/Typography"
import * as Sc from "./style"

export function Footer() {
  return (
    <Sc.Footer>
      <Text type="span" as="span" weight="rgl" size="sml">
        MKS sistemas © Todos os direitos reservados
      </Text>
    </Sc.Footer>
  )
}
